/* promo-popup.js — стабільний тригер + світлий мобайл-фьорст попап із копіюванням коду.
   Правила:
   • Працюємо лише коли є dv або fs_thr у поточному URL (ознака промо-входу),
     або коли вже є ?discount=…
   • Якщо немає discount — підставляємо FORCED_DEFAULT_CODE.
   • Нормалізуємо порядок: ?discount=…&dv=…&fs_thr=… і показуємо попап.
*/
(function () {
  "use strict";

  var FORCED_DEFAULT_CODE = "start";       // Код за замовчуванням для цієї кампанії
  var ALWAYS_SHOW = true;                  // Попап кожного валідного промо-входу
  var DEFAULT_REDIRECT_FALLBACK = "/collections/all";
  var RULES = { "START": { dv: 5, fs_thr: 199, label: "START" } }; // опційно

  // ---- helpers
  function cur(){ return new URL(location.href); }
  function tryURL(s){ try{return new URL(s, location.origin);}catch(e){return null;} }
  function ref(){ return tryURL(document.referrer || ""); }

  function isPromoVisit(){
    var q = cur().searchParams;
    return q.has("dv") || q.has("fs_thr");
  }
  function hasDiscount(){ return cur().searchParams.has("discount"); }

  function normalizeQuery(code, dv, fs){
    var url = cur();
    var rest = [];
    url.searchParams.forEach(function(v,k){
      if(k!=="discount" && k!=="dv" && k!=="fs_thr") rest.push([k,v]);
    });
    var rebuilt = new URL(url.origin + url.pathname);
    if(code) rebuilt.searchParams.set("discount", code);
    if(dv!=null && dv!=="") rebuilt.searchParams.set("dv", String(dv));
    if(fs!=null && fs!=="") rebuilt.searchParams.set("fs_thr", String(fs));
    for(var i=0;i<rest.length;i++) rebuilt.searchParams.append(rest[i][0], rest[i][1]);
    if(rebuilt.toString() !== url.toString()) history.replaceState(null, "", rebuilt.toString());
  }

  function pickParams(code){
    var u = cur(); var r = ref(); var rq = r ? r.searchParams : null;
    function getNum(k){
      var v = u.searchParams.get(k); if(v!==null && v!=="") return Number(v);
      if(rq){ var rv = rq.get(k); if(rv!==null && rv!=="") return Number(rv); }
      var K = code ? String(code).toUpperCase() : "";
      if(RULES[K] && RULES[K][k]!=null) return Number(RULES[K][k]);
      return null;
    }
    return { dv:getNum("dv"), fs_thr:getNum("fs_thr") };
  }

  function detectRedirectTarget(){
    var r = ref(); var t = r && r.searchParams.get("redirect");
    return t || DEFAULT_REDIRECT_FALLBACK;
  }

  // ---- UI (світлий, великі шрифти, мобайл-фьорст, копіювання коду)
  function injectStyles(){
    if(document.getElementById("ua-promo-css")) return;
    var css = document.createElement("style");
    css.id = "ua-promo-css";
    css.textContent =
      /* overlay */
      ".ua-promo-ovl{position:fixed;inset:0;background:rgba(0,0,0,.35);z-index:999998;display:none}" +

      /* card: світлий, без заокруглень, мобайл-фьорст */
      ".ua-promo{position:fixed;left:50%;top:50%;transform:translate(-50%,-50%);width:min(94vw,520px);background:#fff;color:#000;border:2px solid #A42325;padding:0;z-index:999999}" +

      /* header — виразний бейдж */
      ".ua-promo__hdr{display:flex;align-items:center;justify-content:space-between;background:#fff;color:#000;padding:18px;border-bottom:1px solid #eee}" +
      ".ua-promo__title{display:inline-flex;align-items:center;gap:10px;font:800 18px/1.2 system-ui,Segoe UI,Arial}" +
      ".ua-promo__badge{display:inline-block;padding:6px 10px;background:#A42325;color:#fff;font-weight:800;letter-spacing:.3px;text-transform:uppercase}" +
      ".ua-promo__x{appearance:none;background:transparent;border:0;color:#000;font:700 22px/1 system-ui;cursor:pointer;padding:0 4px}" +

      /* content */
      ".ua-promo__cnt{padding:18px;color:#000;font:400 16px/1.45 system-ui,Segoe UI,Arial}" +
      ".ua-promo__note{margin-bottom:12px;color:#333}" +
      ".ua-promo__grid{display:grid;grid-template-columns:1fr;gap:12px}" +
      ".ua-promo__field{border:1px solid #eee;padding:12px 14px;background:#fafafa}" +
      ".ua-promo__cap{display:block;font-size:12px;letter-spacing:.3px;text-transform:uppercase;color:#555;margin-bottom:6px}" +
      ".ua-promo__val{display:block;font-weight:800;font-size:20px;color:#000;word-break:break-word}" +

      /* копіювання */
      ".ua-promo__copy{display:inline-flex;align-items:center;gap:8px;margin-top:8px}" +
      ".ua-promo__copybtn{appearance:none;background:#000;color:#fff;border:0;padding:10px 12px;font:700 14px/1 system-ui;cursor:pointer}" +
      ".ua-promo__copybtn:focus{outline:2px solid #000;outline-offset:2px}" +
      ".ua-promo__copystate{font-size:13px;color:#2e7d32;opacity:0;transition:opacity .2s}" +
      ".ua-promo__copystate.is-on{opacity:1}" +

      /* CTA */
      ".ua-promo__cta{margin-top:14px}" +
      ".ua-promo__btn{display:block;width:100%;appearance:none;background:#A42325;color:#fff;border:0;padding:14px 16px;font:700 17px/1 system-ui;cursor:pointer;text-align:center;text-decoration:none}" +
      ".ua-promo__btn:focus{outline:2px solid #000;outline-offset:2px}" +
      "@media (hover:hover){.ua-promo__btn:hover{filter:brightness(1.06)}}" +

      /* small devices */
      "@media (max-width:420px){" +
        ".ua-promo__hdr{padding:20px}" +
        ".ua-promo__title{font-size:19px}" +
        ".ua-promo__cnt{padding:20px}" +
        ".ua-promo__val{font-size:21px}" +
        ".ua-promo__btn{font-size:18px;padding:16px}" +
      "}";
    document.head.appendChild(css);
  }

  function buildAndShowPopup(meta, redirectUrl){
    injectStyles();
    var ovl = document.createElement("div");
    ovl.className="ua-promo-ovl"; ovl.setAttribute("role","dialog"); ovl.setAttribute("aria-modal","true");

    var box = document.createElement("div");
    box.className="ua-promo";
    box.innerHTML =
      '<div class="ua-promo__hdr">' +
        '<span class="ua-promo__title">' +
          '<span class="ua-promo__badge">Промокод активовано</span>' +
          '<span>Знижка застосована автоматично</span>' +
        '</span>' +
        '<button class="ua-promo__x" aria-label="Закрити" title="Закрити">×</button>' +
      '</div>' +
      '<div class="ua-promo__cnt">' +
        '<p class="ua-promo__note">Промокод вже застосовано. Якщо хочеш скористатися ним пізніше — скопіюй і збережи.</p>' +
        '<div class="ua-promo__grid">' +
          '<div class="ua-promo__field">' +
            '<span class="ua-promo__cap">Код</span>' +
            '<span class="ua-promo__val" id="ua-promo-code"></span>' +
            '<div class="ua-promo__copy">' +
              '<button class="ua-promo__copybtn" type="button" id="ua-promo-copy">Скопіювати код</button>' +
              '<span class="ua-promo__copystate" id="ua-promo-copystate">Скопійовано</span>' +
            '</div>' +
          '</div>' +
          '<div class="ua-promo__field">' +
            '<span class="ua-promo__cap">Знижка</span>' +
            '<span class="ua-promo__val" id="ua-promo-disc"></span>' +
          '</div>' +
          '<div class="ua-promo__field">' +
            '<span class="ua-promo__cap">Доставка</span>' +
            '<span class="ua-promo__val" id="ua-promo-ship"></span>' +
          '</div>' +
        '</div>' +
        '<div class="ua-promo__cta">' +
          '<a class="ua-promo__btn" id="ua-promo-go" href="'+redirectUrl+'">Переглянути товари</a>' +
        '</div>' +
      '</div>';

    ovl.appendChild(box); document.body.appendChild(ovl);

    // значення
    box.querySelector("#ua-promo-code").textContent = meta.label;
    box.querySelector("#ua-promo-disc").textContent = meta.dv!=null ? (meta.dv+"%") : "—";
    box.querySelector("#ua-promo-ship").textContent = meta.fs_thr!=null ? ("Безкоштовна від "+meta.fs_thr+" zł") : "—";

    // копіювання
    var copyBtn = box.querySelector("#ua-promo-copy");
    var copyState = box.querySelector("#ua-promo-copystate");
    function showCopied(){
      copyState.classList.add("is-on");
      setTimeout(function(){ copyState.classList.remove("is-on"); }, 1600);
    }
    function doCopy(text){
      if (!text) return;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(showCopied).catch(function(){
          fallback();
        });
      } else { fallback(); }
      function fallback(){
        try{
          var ta = document.createElement("textarea");
          ta.value = text; ta.setAttribute("readonly",""); ta.style.position="fixed"; ta.style.opacity="0";
          document.body.appendChild(ta); ta.select(); document.execCommand("copy"); document.body.removeChild(ta);
          showCopied();
        }catch(e){}
      }
    }
    copyBtn.addEventListener("click", function(){
      var code = box.querySelector("#ua-promo-code").textContent.trim();
      doCopy(code);
    });

    // закриття
    function close(){ ovl.remove(); }
    ovl.addEventListener("click", function(e){ if(e.target===ovl) close(); });
    box.querySelector(".ua-promo__x").addEventListener("click", close);

    ovl.style.display="block";
  }

  // ---- main
  function main(){
    // Працюємо ТІЛЬКИ для промо-входів
    if(!isPromoVisit() && !hasDiscount()) return;

    var url = cur();
    var code = (url.searchParams.get("discount") || "").trim().toLowerCase();

    // Якщо discount відсутній, але це промо-візит по dv/fs_thr — підставляємо дефолтний код
    if(!code && isPromoVisit()){
      code = FORCED_DEFAULT_CODE;
      url.searchParams.set("discount", code);
      history.replaceState(null, "", url.toString());
    }
    if(!code) return;

    var params = pickParams(code);
    normalizeQuery(code, params.dv, params.fs_thr);

    if(!ALWAYS_SHOW){
      try{
        var k = "ua_promo_seen_code", last = localStorage.getItem(k);
        if(String(last||"").toUpperCase() === String(code).toUpperCase()) return;
        localStorage.setItem(k, String(code).toUpperCase());
      }catch(e){}
    }

    var label = (RULES[String(code).toUpperCase()] && RULES[String(code).toUpperCase()].label) || code;
    var meta = { code, label, dv: params.dv, fs_thr: params.fs_thr };
    var redirectUrl = detectRedirectTarget();

    if(document.readyState==="loading"){
      document.addEventListener("DOMContentLoaded", ()=>buildAndShowPopup(meta, redirectUrl));
    }else{
      buildAndShowPopup(meta, redirectUrl);
    }
  }

  document.addEventListener("DOMContentLoaded", main);
  window.addEventListener("pageshow", main);
  document.addEventListener("shopify:section:load", main);
})();
